// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2V0X6","icon":"styles_icon__73mR6"};